import { render, staticRenderFns } from "./Unexpired.vue?vue&type=template&id=55ba1f9f&"
import script from "./Unexpired.vue?vue&type=script&lang=js&"
export * from "./Unexpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports